module.exports = __webpack_public_path__ + "assets/images/project/cambodia.jpg?v=ebda70d6";